import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const gotosocial = defineConnector({
  identifier: "gotosocial",
  name: "GoToSocial",
  tagLine: "Lightweight ActivityPub social network server",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your GoToSocial access token",
      items: [
        {
          kind: "markdown",
          content:
            "Create an application in your GoToSocial instance's settings and obtain an access token via the OAuth flow.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          placeholder: "https://gotosocial.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your GoToSocial instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/api/v1/accounts/verify_credentials`,
  },
});
